// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* home page category error */
.home_alert_area {
  width: 74%;
  margin: 20px auto 0px;
}

.alert.home_alert_div {
  background: #f5f9ff;
  padding: 16px;
  border-radius: 5px;
  position: relative;
}

.home_alert_div button {
  opacity: 1;
  position: absolute;
  top: 0;
  right: 0;
  border: 0;
  border-radius: 50%;
}

.home_alert_div h3 {
  color: #2e2e2e;
  font-size: 22px;
  font-family: 'Poppins', sans-serif;
  margin-bottom: 0;
}

.home_alert_div p {
  color: #707070;
  font-family: 'Poppins', sans-serif;
}

.cursor-pointer {
  cursor: pointer;
}

.home-search-data-box,
.search-data-box {
  left: 0px;
  top: 50px;
  width: auto;
  right: 0;
}

.relative {
  position: relative;
}

.input-outer-div .custom-input-field {
  border: 1px solid #d3d3d3;
  border-radius: 6px;
}

.search-category-visit-store-btn {
  color: inherit;
}

.home-page-all-sections {
  margin-top: 15px;
}

/* for age confirmation modal */
.age_popup_logo_area {
  width: 35%;
  height: auto;
  margin: 10px auto 0;
  text-align: center;
}
.age_popup_content_area {
  width: 100%;
  height: auto;
}
.age_popup_content_area h4 {
  margin: 30px 0 20px;
  text-align: center;
  font-size: 22px;
  color: #000;
  font-weight: 600;
  font-family: QuicksandBold !important;
}

.age_popup_content_area p {
  font-size: 14px;
  font-family: QuicksandMedium !important;
  color: #232323;
  text-align: center;
  margin-bottom: 10px !important;
  font-weight: 300;
}

.age_popup_content_area span {
  font-weight: 600;
}

.age_popup_button_area {
  width: 100%;
  height: auto;
  text-align: center;
  margin: 20px 0;
}
.age-confirmation-modal-body {
  padding: 20px 30px;
}

.age_popup_button_area {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 15px;
}

.age_popup_black_btn,
.age_popup_grey_btn {
  color: #ffffff;
  font-size: 12px;
  padding: 12px 12px;
  text-decoration: none;
  flex: 1 1;
  text-align: center;
  border-radius: 100px;
  outline: none;
  border: 0;
  font-family: QuicksandBold !important;
  font-weight: 500;
}

.age_popup_black_btn {
  background-color: #000;
  white-space: nowrap;
}
.age_popup_grey_btn {
  background-color: #ccc;
  color: #565656;
  white-space: nowrap;
}

.age_popup_uber_wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 8px;
}

.age_popup_uber_row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.age_popup_uber_icon {
  width: 24px;
  height: 24px;
}

.age_popup_uber_text {
  color: #6a7282;
  text-align: center;
  font-family: 'Jost', QuicksandMedium, system-ui, -apple-system, BlinkMacSystemFont,
    'Segoe UI', sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 22.5px; /* 150% */
}

.age_popup_uber_text_uber {
  color: #000000;
}

.stateDropdown .modal-form-single-input {
  /* height: 10px; */
}

.flex-1 {
  flex: 1 1;
}

.single-store-wishlist .q-sv-single-product {
  margin-right: 26px;
  /* width: 242px; */
}

.new__input .modal-form-single-input .css-fi4tqy {
  height: 2.1rem;
  padding: 12px 12px 4px !important;
}

.no-stock-variant-product,
.quickvee-store-cart-items
  > .quickvee-store-cart-single-item
  > .quickvee-scsi-content
  > p.no-stock-variant-product {
  font-size: 15px;
  font-family: QuicksandMedium !important;
  text-transform: capitalize !important;
  color: red;
  font-weight: 500;
  line-height: 1.25;
  margin: 10px 0px;
}

.payment-stepper-cart
  > .payment-stepper-checkout-item
  > .payment-stepper-checkout-content
  > .payment-checkout-with-login:disabled,
.quickvee-store-topbar-cart > .quickvee-store-cart-checkout-btn > .disable-link,
.quickvee-store-cart-checkout-btn .button-for-minamount-on-delivery:disabled {
  pointer-events: all;
  cursor: not-allowed;
  background-color: rgb(199, 199, 199);
  border-color: rgb(199, 199, 199);
  color: gray;
}

.payment-stepper-cart
  > .payment-stepper-checkout-item
  > .payment-stepper-checkout-content
  > .payment-checkout-as-guest:disabled {
  pointer-events: all;
  cursor: not-allowed;
  border-color: rgb(199, 199, 199);
  color: gray;
}

.payment-page-wishlist-cart-items.error {
  border: 1px solid red;
}

@media (max-width: 480px) {
  .payment-page-wishlist-cart-items.error {
    border: unset;
    border-top: 1px solid red !important;
    border-bottom: 1px solid red !important;
  }
}
.quickvee-store-cart-items > .quickvee-store-cart-single-item.error {
  border-top: 1px solid red;
  border-bottom: 1px solid red;
}

.quickvee-store-cart-checkout-btn {
  display: flex;
  flex-direction: column;
}

.out-of-stock-products-info {
  color: red;
  background-color: #f0f0f0;
  border-radius: 4px;
  display: flex;
  justify-content: start;
  align-items: center;
  padding: 10px;
  margin-bottom: 10px;
  font-size: 16px;
  font-family: QuicksandMedium !important;
  font-weight: 500;
  line-height: 1.25;
}
`, "",{"version":3,"sources":["webpack://./src/Styles/custom.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,SAAS;EACT,SAAS;EACT,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,SAAO;EACP,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,SAAS;EACT,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB;0BACwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAE,SAAS;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iCAAiC;AACnC;;AAEA;;;;;EAKE,eAAe;EACf,uCAAuC;EACvC,qCAAqC;EACrC,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;;;EAME,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;EACpC,gCAAgC;EAChC,WAAW;AACb;;AAEA;;;;EAIE,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;IACb,oCAAoC;IACpC,uCAAuC;EACzC;AACF;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["/* home page category error */\n.home_alert_area {\n  width: 74%;\n  margin: 20px auto 0px;\n}\n\n.alert.home_alert_div {\n  background: #f5f9ff;\n  padding: 16px;\n  border-radius: 5px;\n  position: relative;\n}\n\n.home_alert_div button {\n  opacity: 1;\n  position: absolute;\n  top: 0;\n  right: 0;\n  border: 0;\n  border-radius: 50%;\n}\n\n.home_alert_div h3 {\n  color: #2e2e2e;\n  font-size: 22px;\n  font-family: 'Poppins', sans-serif;\n  margin-bottom: 0;\n}\n\n.home_alert_div p {\n  color: #707070;\n  font-family: 'Poppins', sans-serif;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.home-search-data-box,\n.search-data-box {\n  left: 0px;\n  top: 50px;\n  width: auto;\n  right: 0;\n}\n\n.relative {\n  position: relative;\n}\n\n.input-outer-div .custom-input-field {\n  border: 1px solid #d3d3d3;\n  border-radius: 6px;\n}\n\n.search-category-visit-store-btn {\n  color: inherit;\n}\n\n.home-page-all-sections {\n  margin-top: 15px;\n}\n\n/* for age confirmation modal */\n.age_popup_logo_area {\n  width: 35%;\n  height: auto;\n  margin: 10px auto 0;\n  text-align: center;\n}\n.age_popup_content_area {\n  width: 100%;\n  height: auto;\n}\n.age_popup_content_area h4 {\n  margin: 30px 0 20px;\n  text-align: center;\n  font-size: 22px;\n  color: #000;\n  font-weight: 600;\n  font-family: QuicksandBold !important;\n}\n\n.age_popup_content_area p {\n  font-size: 14px;\n  font-family: QuicksandMedium !important;\n  color: #232323;\n  text-align: center;\n  margin-bottom: 10px !important;\n  font-weight: 300;\n}\n\n.age_popup_content_area span {\n  font-weight: 600;\n}\n\n.age_popup_button_area {\n  width: 100%;\n  height: auto;\n  text-align: center;\n  margin: 20px 0;\n}\n.age-confirmation-modal-body {\n  padding: 20px 30px;\n}\n\n.age_popup_button_area {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  gap: 15px;\n}\n\n.age_popup_black_btn,\n.age_popup_grey_btn {\n  color: #ffffff;\n  font-size: 12px;\n  padding: 12px 12px;\n  text-decoration: none;\n  flex: 1;\n  text-align: center;\n  border-radius: 100px;\n  outline: none;\n  border: 0;\n  font-family: QuicksandBold !important;\n  font-weight: 500;\n}\n\n.age_popup_black_btn {\n  background-color: #000;\n  white-space: nowrap;\n}\n.age_popup_grey_btn {\n  background-color: #ccc;\n  color: #565656;\n  white-space: nowrap;\n}\n\n.age_popup_uber_wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-top: 8px;\n}\n\n.age_popup_uber_row {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.age_popup_uber_icon {\n  width: 24px;\n  height: 24px;\n}\n\n.age_popup_uber_text {\n  color: #6a7282;\n  text-align: center;\n  font-family: 'Jost', QuicksandMedium, system-ui, -apple-system, BlinkMacSystemFont,\n    'Segoe UI', sans-serif;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 22.5px; /* 150% */\n}\n\n.age_popup_uber_text_uber {\n  color: #000000;\n}\n\n.stateDropdown .modal-form-single-input {\n  /* height: 10px; */\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.single-store-wishlist .q-sv-single-product {\n  margin-right: 26px;\n  /* width: 242px; */\n}\n\n.new__input .modal-form-single-input .css-fi4tqy {\n  height: 2.1rem;\n  padding: 12px 12px 4px !important;\n}\n\n.no-stock-variant-product,\n.quickvee-store-cart-items\n  > .quickvee-store-cart-single-item\n  > .quickvee-scsi-content\n  > p.no-stock-variant-product {\n  font-size: 15px;\n  font-family: QuicksandMedium !important;\n  text-transform: capitalize !important;\n  color: red;\n  font-weight: 500;\n  line-height: 1.25;\n  margin: 10px 0px;\n}\n\n.payment-stepper-cart\n  > .payment-stepper-checkout-item\n  > .payment-stepper-checkout-content\n  > .payment-checkout-with-login:disabled,\n.quickvee-store-topbar-cart > .quickvee-store-cart-checkout-btn > .disable-link,\n.quickvee-store-cart-checkout-btn .button-for-minamount-on-delivery:disabled {\n  pointer-events: all;\n  cursor: not-allowed;\n  background-color: rgb(199, 199, 199);\n  border-color: rgb(199, 199, 199);\n  color: gray;\n}\n\n.payment-stepper-cart\n  > .payment-stepper-checkout-item\n  > .payment-stepper-checkout-content\n  > .payment-checkout-as-guest:disabled {\n  pointer-events: all;\n  cursor: not-allowed;\n  border-color: rgb(199, 199, 199);\n  color: gray;\n}\n\n.payment-page-wishlist-cart-items.error {\n  border: 1px solid red;\n}\n\n@media (max-width: 480px) {\n  .payment-page-wishlist-cart-items.error {\n    border: unset;\n    border-top: 1px solid red !important;\n    border-bottom: 1px solid red !important;\n  }\n}\n.quickvee-store-cart-items > .quickvee-store-cart-single-item.error {\n  border-top: 1px solid red;\n  border-bottom: 1px solid red;\n}\n\n.quickvee-store-cart-checkout-btn {\n  display: flex;\n  flex-direction: column;\n}\n\n.out-of-stock-products-info {\n  color: red;\n  background-color: #f0f0f0;\n  border-radius: 4px;\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  padding: 10px;\n  margin-bottom: 10px;\n  font-size: 16px;\n  font-family: QuicksandMedium !important;\n  font-weight: 500;\n  line-height: 1.25;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
